// removed by extract-text-webpack-plugin
module.exports = {"list":"src-pages----services-module---list---XYbuj","button":"src-pages----services-module---button---2TZ6Q"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/services.module.scss
// module id = 940
// module chunks = 267660657819475